export default __webpack_public_path__ + "static/presse-huettn-1-preview-b6bf1d39b3d64860056011bce003884a.jpg";